import React from "react";
import "../styles/VideoSection.css"; 

const VideoSection = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  return (
    <>
    <section className="video-section">
        <h2><span className="highlight">Mahadev:</span> Happy Clients Always <span className="highlight">Love Us</span></h2>
        {/* Description Section */}
        <div className="video-description">
          <p>
          At Mahadev Book Official, our mission is to redefine your online gaming journey through excellence and innovation. We’re committed to delivering a secure, user-friendly, and premium experience that keeps our users coming back. The positive testimonials from our community speak volumes about the trust and satisfaction we’ve earned. Join the growing Mahadev Book family and experience a platform celebrated for its reliability, excitement, and superior service.
          </p>
        </div>

        {/* Statistics Section */}
        <div className="statistics">
          {/* Happy Clients */}
          <div className="stat-item">
            <h3>42,000+</h3>
            <p>Happy Clients</p>
          </div>
          {/* Application Users */}
          <div className="stat-item">
            <h3>2.5 Lakh+</h3>
            <p>Application users</p>
          </div>
          {/* Rating */}
          <div className="stat-item">
            <h3>4.8</h3>
            <p>Rating</p>
          </div>
        </div>
        <div className="vdo-btn">
      <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us Now
          </a>
    </div>
    </section>
    </>
  );
};

export default VideoSection;
